import React from 'react';
import './aboutus.css';

function AboutUs() {
  return (
    <div className="dharma-container">

      {/* Header */}
      <div className="sacred-header">
        <h1 className="enlightened-title">
          About Sri Dhamma Samadhi Buddhist Center
        </h1> 
      </div>

      {/* Introduction Section */}
      <section className="golden-section">
        <div className="section-content">
          <p className="dharma-text">
            Sri Dhamma Samadhi Buddhist Center, situated in the serene surroundings of Bokundara, Piliyandala, 
            was founded in the year 2008 with the noble aspiration of upholding and propagating the sublime teachings 
            of the Supreme Buddha. This sacred sanctuary was established through the compassionate leadership of Venerable 
            Hagarapitiye Maithree Thero and Venerable Hipankande Saddhasiri Thero. The spiritual guidance and advisory 
            blessings of Venerable Embilipitiye Rahula Thero and Venerable Korathota Dhamma Dassi Thero continue to 
            strengthen the foundation of this esteemed institution. The temple was generously offered by the devoted 
            businessman Mr. Weerasinghe and his family, whose meritorious contribution made the establishment of this center possible.
              <br /><br />
            Sri Dhamma Samadhi Buddhist Center stands as a beacon of light dedicated to the protection of the Buddha Sasana and 
            the dissemination of the Noble Dhamma both locally and internationally. At present, more than ten resident Bhikkhus 
            diligently engage in the study, practice, and teaching of the Dhamma while rendering invaluable service for the 
            spiritual, moral, and social upliftment of society. Through religious observances, educational programs, social 
            service initiatives, and international outreach, the center continues its sacred mission of nurturing wisdom, 
            compassion, and harmony among all beings.
          

          </p>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="saffron-section">
        <h2 className="section-title">Our Spiritual Leadership</h2>

        <div className="leadership-grid">
          <div className="leader-card">
            <h3>Chief Spiritual Preceptor</h3>
            <p>Senior Venerable Monk of the Maha Sangha</p>
          </div>

          <div className="leader-card">
            <h3>Spiritual Advisor</h3>
            <p>Guiding the community with compassion and wisdom</p>
          </div>

          <div className="leader-card">
            <h3>Dhamma Education Coordinator</h3>
            <p>Overseeing religious and educational activities</p>
          </div>

          <div className="leader-card">
            <h3>Lay Support Committee</h3>
            <p>Facilitating social service and welfare initiatives</p>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="golden-section">
        <h2 className="section-title">Our Vision</h2>

        <div className="mission-grid">
          <div className="mission-item">
            <div className="mission-icon">✓</div>
            <p>
              To be a leading Buddhist spiritual center devoted to the preservation of the Buddha Sasana
              and the global dissemination of the Noble Dhamma, fostering peace, wisdom, and compassion
              for the betterment of humanity.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="saffron-section">
        <h2 className="section-title">Our Mission</h2>

        <div className="mission-grid">
          {[
            "To safeguard and promote the teachings of the Supreme Buddha in their pure and authentic form",
            "To provide systematic Dhamma education and spiritual training for Bhikkhus and lay devotees",
            "To conduct religious, social, and community development programs for the well-being of society",
            "To expand Dhamma activities nationally and internationally for the spiritual upliftment of future generations",
            "To cultivate moral values, mindfulness, harmony, and compassion among all communities"
          ].map((item, index) => (
            <div key={index} className="mission-item">
              <div className="mission-icon">✓</div>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Blessing Footer */}
      <footer className="blessing-footer">
        <p className="blessing-text">
          May this sacred center continue to serve as a beacon of wisdom, compassion, and harmony.
          May all who enter find peace of mind, clarity of heart, and progress on the Noble Path
          toward liberation.
        </p>
      </footer>

    </div>
  );
}

export default AboutUs;